<template>
	<div class="container">
		<van-swipe :autoplay="5000" :duration="150">
			<div v-for="(item, index) in banner" :key="index">
				<van-swipe-item :data-index="index">
					<img :src="item.pictureUrl" class="banner"/>
				</van-swipe-item>
			</div>
		</van-swipe >

		<div class="nav">
			<div class="nav-items" :class="timeIndex==index?'nav-items-acitve':''" v-for="(item,index) in timeList" :key="index" @click="navClick(index,item)">
				<span :class="timeIndex==index?'titleActive':'title'">{{item.startTimeOfDate}}</span>
				<span>{{item.title}}</span>
			</div>
		</div>
		<!--商品列表-->
		<van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="onLoad">
			<div class="goods-list">
				<div v-for="(item, index) in productList" :key="index" @click="detail(item)">
					<div class="tui-pro-item">
						<img :src="item.picUrl" class="tui-pro-img"  mode="widthFix" />
						<div class="tui-pro-content">
							<div class="tui-pro-tit">{{ item.mpName }}</div>
							<div class="tui-title">秒杀价:</div>
							<div class="tui-pro-price">
								<p class="tui-sale-price">￥{{ item. promPrice }}</p>
								<p class="tui-factory-price">￥{{ item.salePriceWithTax }}</p>
							</div>
							<div class="flex justify-between align-center">
								<div class="flex align-center">
									<div class="progress-cont">
										<van-progress pivot-text="" color="#ee0a24" :percentage="50" />
									</div>
									<span class="progress-text">50%</span>
								</div>
								<div class="tui-pro-pay" @click="purchase">立即抢购</div>
							</div>
						</div>
					</div>
				</div>
			</div>
		</van-list>
	</div>
</template>

<script>
import { queryPeriodTime,querySeckilledProductList } from "@/api/api";
import notData from "@/components/notData";
export default {
    components: {

    },
	data() {
		return {
			banner:[
				{pictureUrl:'https://i.loli.net/2020/11/19/fBrEqTb4htoPdiR.png'}
			],
			timeList:[],
			timeIndex:0,
			productList: [],
			// productList: [],
			loading: false, // 是否加载完成
			finished: true, // 是否加载完成
			list: [], //数据
			limit: 10, // 每次请求条数
			start: 1, // 开始页数
		};
	},
	mounted: function(options) {
		if (this.$route.query.token) {
			this.$cookies.set('token', this.$route.query.token);
		}
		this.getTime();
	},
	methods: {
		// list 组件请求数据
		onLoad() {
			this.getList();
		},
		// 请求数据
		async getList(id) {
			let sendData = {
				timeId: id,
				start: this.start,
				limit: this.limit
			};
			const res = await querySeckilledProductList(sendData);
			if (res.code == "0000") {
				this.productList = this.productList.concat(res.data.rows);
				if (res.data.rows.length < this.limit) {
					this.finished = true;
				}
				this.start += 1;
				this.loading = false;
			} else {
				this.$toast(res.msg);
			}
		},
		// 请求时间数据
		async getTime() {
			let sendData = {};
			const res = await queryPeriodTime(sendData);
			if (res.code == "0000") {
				this.getList(res.data[0].timeId);
				this.timeList = res.data;
			} else {
				this.$toast(res.msg);
			}
		},
		purchase: function() {

		},
		navClick(index,item){
			this.start=1;
			this.productList=[];
			this.timeIndex=index;
			this.getList(item.timeId)
		},
		detail(item) {
			this.$router.push({
				path: "/productDetailSickill",
				query:{
					id:item.mpId,
					promotionId:item.promotionId
				}
			});
			location.reload();
		},
	}
};
</script>

<style lang="scss" scoped>
.container {
	background-color:#f1f1f1 ;
}
.banner{
	width: 750px;
	height: 280px;
}
.nav-items-acitve{
	background: $theme-color-main;
	color: #ffffff;
}
.nav{
	display: flex;
	align-items: center;
	height: 110px;
	background: #ffffff;
	justify-content: space-evenly;
	.nav-items{
		text-align: center;
		width: 134px;
		height: 110px;
		display: flex;
		justify-content: center;
		flex-direction: column;
		p{
			font-size: 22px;
			color: #999999;
		}
		.title{
			font-size: 36px;
			color: #333333;
		}
		.titleActive{
			font-size: 36px;
			color: #ffffff;
		}
	}
}
/* 商品列表*/
.tui-product-list {
	display: flex;
	justify-content: space-between;
	flex-direction: row;
	flex-wrap: wrap;
	box-sizing: border-box;
}
.goods-list{
	background-image: url("../../../static/images/seckill/bg-image.png");
	background-size: 100% 100%;
	padding: 47px;
}
.tui-title{
	font-size: 19px;
	font-family: SourceHanSansCN Regular, SourceHanSansCN Regular-Regular;
	font-weight: bold;
	font-style: italic;
	color: #000000;
}
.tui-product-container {
	flex: 1;
	padding-left: 20px;
	display: flex;
	flex-wrap: wrap;
	justify-content: space-between;
}

.tui-product-container:last-child {
	padding-right: 20px;
}

.tui-pro-item {
	box-sizing: border-box;
	overflow: hidden;
	display: flex;
	background-image: url("../../../static/images/seckill/item.png");
	background-size: 100% 100%;
	width: 665px;
	height: 261px;
	padding: 20px 30px;
}

.tui-flex-list {
	display: flex;
	border-bottom: #CBCBCB 1px solid;
	padding: 10px 0;
	margin-bottom: 0;
}

.tui-flex-list-2{
	width: 49%;
}

.tui-pro-img {
	width: 185px;
	height: 200px;
	border-radius: 5px;
	display: block;
}

.tui-proimg-list {
	width: 260px;
	height: 260px !important;
	flex-shrink: 0;
}

.tui-pro-content {
	display: flex;
	flex-direction: column;
	/*justify-content: space-between;*/
	box-sizing: border-box;
	margin-left: 18px;
	width: 100%;
}

.tui-pro-tit {
	color: #000000;
	font-size: 25px;
	font-weight: 500;
	word-break: break-all;
	overflow: hidden;
	text-overflow: ellipsis;
	display: -webkit-box;
	-webkit-box-orient: vertical;
	-webkit-line-clamp: 2;
	height: 70px;
}

.tui-pro-price {
	display: flex;
	align-items: center;
}

.tui-sale-price {
	font-size: 46px;
	font-family: Arial Bold, Arial Bold-Bold;
	font-weight: 700;
	font-style: italic;
	background: linear-gradient(#ff3434 0%, #c00707 100%);
	-webkit-background-clip: text;
	color: transparent;
}
.progress-text{
	font-size: 16px;
	color: #999999;
	padding-left: 10px;
}
.progress-cont{
	width: 196px;
}

.tui-factory-price {
	font-size: 24px;
	color: #727171;
	text-decoration: line-through;
	padding-left: 12px;
	padding-bottom: 5px;
}

.tui-pro-pay {
	width: 140px;
	height: 40px;
	background: linear-gradient(#ff3434 0%, #c00707 100%);
	border-radius: 10px;
	font-size: 24px;
	font-weight: 600;
	text-align: center;
	color: #ffffff;
	line-height: 40px;
}
/* 商品列表*/
</style>
